<template>
  <div id="wangEditor" style="color: #000"></div>
</template>

<script>
import E from 'wangeditor'

export default {
  data() {
    return {
      editor: null,
      timer: null
    }
  },
  props: {
    defaultValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    defaultValue(val) {
      this.editor.txt.html(val) // 重新设置编辑器内容
    }
  },
  created() {
    this.$nextTick(() => {
      this.createdEditor()
    })
  },
  methods: {
    // 创建富文本编辑器
    createdEditor() {
      this.editor = new E('#wangEditor')
      // 设置层级，不然像我遇到了与DatePicker日期选择器下拉点击日期冲突的问题
      this.editor.config.zIndex = 1
      this.editor.config.height = 500 // 设置编辑区域高度为 600px
      // 上传图片
      this.editor.config.uploadImgServer = '/merchant.php/upload_file/uploadFile?type=INFO_PIC'
      this.editor.config.uploadFileName = 'file'
      // this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 2M
      this.editor.config.uploadImgMaxLength = 1 // 一次最多上传 1 个文件
      this.editor.config.uploadImgHooks = {
        customInsert: function(insertImgFn, result) {
          // result 即服务端返回的接口
          var url = result.data.url
          // 插入图片
          insertImgFn(url)
        }
      }
      // 上传视频
      this.editor.config.uploadVideoServer = '/merchant.php/upload_file/uploadFile?type=INFO_PIC' // 配置 server 接口地址
      this.editor.config.uploadVideoMaxSize = 64 * 1024 * 1024 // 64m
      this.editor.config.uploadVideoAccept = ['mp4'] // 限制类型
      this.editor.config.uploadVideoName = 'file' // 自定义 fileName
      this.editor.config.uploadVideoHooks = {
        customInsert: function(insertVideoFn, result) {
          // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
          insertVideoFn(result.data.url)
        }
      }
      // 配置菜单栏，设置不需要的菜单
      this.editor.config.excludeMenus = [ 'emoticon', 'quote' ]

      // 配置触发 onchange 的时间频率，默认为 200ms
      this.editor.config.onchangeTimeout = 1000 // 修改为 1000ms
      // 编辑器的事件，每次改变会获取其html内容（html内容是带标签的）
      // 在这可以获取编辑器正在输入的内容，刚开始做了一个编辑字数大致限制，因为标签没办法计算精准
      this.editor.config.onchange = html => {
        // 防抖
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.$emit('change', html)
        }, 300)
      }
      this.editor.create()
      this.editor.txt.html(this.defaultValue) // 重新设置编辑器内容
    }
  }
}
</script>

<style scoped>
/deep/h1, /deep/h2, /deep/h3, /deep/h4, /deep/h5, /deep/h6{
  color: #000
}
</style>
